import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../SignUp/SignUp.css';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { sendVerificationEmail } = useAuth();

  const handleResendEmail = async () => {
    try {
      setMessage('');
      setError('');
      setLoading(true);
      await sendVerificationEmail();
      setMessage('A new verification email has been sent to your inbox.');
    } catch (err) {
      setError('Failed to send verification email. Please try again.');
    }
    setLoading(false);
  };

  return (
    <>
      <title>Verify Email - WizeHelper</title>
      <div className="signup-container">
      <div className="signup-card">
        <h1 className="signup-title">Verify Your Email</h1>
        <p className="signup-subtitle">A verification email has been sent to your inbox. Please check your email and click the verification link to continue. If you don't see it, please check your spam folder.</p>
        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <button onClick={handleResendEmail} className="submit-button" disabled={loading}>
          {loading ? 'Sending...' : 'Resend Verification Email'}
        </button>
      </div>
    </div>
    </>
  );
};

export default VerifyEmail;